import { DateTime } from "luxon";

import { IProductionDashboardBayVehicle } from "../models/ProductionDashboard";

type AssemblyTimedVehicle = Pick<
  IProductionDashboardBayVehicle,
  "currentAssemblyElapsedSeconds" | "currentAssemblyStartedOn"
>;

// Worked time on the vehicle's current assembly: the accumulated time from completed (paused)
// session segments plus, if a session is running, the time since it started.
export function assemblyElapsedSeconds(vehicle: AssemblyTimedVehicle, now: DateTime): number {
  const runningSeconds = vehicle.currentAssemblyStartedOn
    ? Math.max(
        0,
        now.diff(DateTime.fromISO(vehicle.currentAssemblyStartedOn, { zone: "utc" }), "seconds")
          .seconds
      )
    : 0;

  return (vehicle.currentAssemblyElapsedSeconds ?? 0) + runningSeconds;
}

// m:ss under an hour, h:mm:ss from then on.
export function formatAssemblyDuration(totalSeconds: number): string {
  const s = Math.max(0, Math.floor(totalSeconds));
  const hours = Math.floor(s / 3600);
  const minutes = Math.floor((s % 3600) / 60);
  const seconds = s % 60;
  const pad = (n: number) => String(n).padStart(2, "0");
  return hours > 0 ? `${hours}:${pad(minutes)}:${pad(seconds)}` : `${minutes}:${pad(seconds)}`;
}
